import { render, staticRenderFns } from "./DevicesTable.vue?vue&type=template&id=671481aa&scoped=true&"
import script from "./DevicesTable.vue?vue&type=script&lang=js&"
export * from "./DevicesTable.vue?vue&type=script&lang=js&"
import style0 from "./DevicesTable.vue?vue&type=style&index=0&id=671481aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671481aa",
  null
  
)

export default component.exports